module.exports = __webpack_public_path__ + "static/media/mtn-lake-center.8a9aa279.png";